import React, { useEffect, useState } from 'react';
import Select from '@gerdau/hefesto/Select/Select';
import { Button, Icon } from '@gerdau/hefesto';
import { Form, Input } from 'antd';
import AdminBpInput from '../../components/AdminBpInput';
import { FilterInputContainer } from '../../components/Commons/Filters/styles';
import {
  HeaderSection,
  FavoritesTitle,
  FavoritesSubtitle,
  SelectorsRow,
  AdminSearchRow
} from './styles';

interface SelectOption {
  label: string;
  value: string;
  descriptions: string[];
}

interface FavoritesHeaderProps {
  emitterId: string;
  receiverId: string;
  emitterOptions: SelectOption[];
  receiverOptions: SelectOption[];
  isEmitterDisabled: () => boolean;
  isReceiverDisabled: () => boolean;
  handleSelectEmitter: (id: string) => void;
  handleSelectReceiver: (id: string) => void;
  isUserAdmin: boolean;
  newSearchEmitterInputAdmin: boolean;
  onAdminSearch: (id: string) => void;
  customersLoading: boolean;
  bpError: boolean;
  customerName: string | undefined;
}

const FavoritesHeader: React.FC<FavoritesHeaderProps> = ({
  emitterId,
  receiverId,
  emitterOptions,
  receiverOptions,
  isEmitterDisabled,
  isReceiverDisabled,
  handleSelectEmitter,
  handleSelectReceiver,
  isUserAdmin,
  newSearchEmitterInputAdmin,
  onAdminSearch,
  customersLoading,
  bpError,
  customerName
}) => {
  const [adminInputValue, setAdminInputValue] = useState(emitterId);

  useEffect(() => {
    if (emitterId === '') setAdminInputValue('');
  }, [emitterId]);

  return (
    <HeaderSection>
      <FavoritesTitle>Lista de favoritos</FavoritesTitle>
      <FavoritesSubtitle>
        Selecione emissor e recebedor para acompanhar os seus produtos
        favoritos. Aproveite para inserir seus produtos ao carrinho.
      </FavoritesSubtitle>
      <SelectorsRow>
        <div>
          {isUserAdmin ? (
            newSearchEmitterInputAdmin ? (
              <AdminSearchRow>
                <AdminBpInput
                  title="Emissor do pedido"
                  customerId={emitterId}
                  setCustomerId={() => undefined}
                  onSearch={onAdminSearch}
                  onChange={setAdminInputValue}
                  loading={customersLoading}
                  bpError={bpError}
                  customerName={customerName}
                  disabled={isEmitterDisabled()}
                />
                <Button
                  name="btn-buscar-emissor-favoritos"
                  variant="primary"
                  onClick={() => onAdminSearch(adminInputValue)}
                  disabled={!adminInputValue || customersLoading}
                  icon={<Icon option="Search" size="xs" />}
                >
                  Buscar
                </Button>
              </AdminSearchRow>
            ) : (
              <FilterInputContainer>
                <h4>Emissor do pedido</h4>
                <Form>
                  <Form.Item
                    hasFeedback={customersLoading}
                    validateStatus={bpError ? 'error' : ''}
                    help={bpError ? 'BP não encontrado' : customerName}
                  >
                    <Input.Search
                      loading={customersLoading}
                      disabled={isEmitterDisabled()}
                      placeholder="Digite o BP"
                      value={emitterId}
                      onChange={(e) => handleSelectEmitter(e.target.value)}
                      onSearch={onAdminSearch}
                    />
                  </Form.Item>
                </Form>
              </FilterInputContainer>
            )
          ) : (
            <Select
              label="Emissor do pedido"
              name="select-emissor-favoritos"
              options={emitterOptions}
              value={emitterId}
              onSelect={(customerId) =>
                handleSelectEmitter(customerId as string)
              }
              isMultipleSelect={false}
              placeholder="Selecione um emissor"
              disabled={isEmitterDisabled()}
            />
          )}
        </div>
        <div>
          <Select
            label="Recebedor do pedido"
            name="select-recebedor-favoritos"
            options={receiverOptions}
            value={receiverId}
            onSelect={(newReceiverId) =>
              handleSelectReceiver(newReceiverId as string)
            }
            isMultipleSelect={false}
            placeholder="Selecione um recebedor"
            disabled={isReceiverDisabled() || isEmitterDisabled()}
          />
        </div>
      </SelectorsRow>
    </HeaderSection>
  );
};

export default FavoritesHeader;
